// extracted by mini-css-extract-plugin
module.exports = {"swiper":"styles-styles-module--swiper--2IGOr"};